import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Navbar } from '../components/Navbar'
import { Footer } from '../components/Footer'
import { Button } from '../components/ui/Button'
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card'
import {ArrowLeft, FileText} from 'lucide-react'

export function TermsOfService() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="container mx-auto px-4 py-6 pb-20 max-w-4xl">
        <Button 
          variant="ghost" 
          onClick={() => navigate('/')}
          className="mb-4"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Voltar
        </Button>

        <Card className="border border-red-200">
          <CardHeader className="text-center">
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 rounded-full bg-red-600 flex items-center justify-center">
                <FileText className="h-8 w-8 text-white" />
              </div>
            </div>
            <CardTitle className="text-3xl">Termos de Uso</CardTitle>
            <p className="text-sm text-gray-600 mt-2">
              Última atualização: {new Date().toLocaleDateString('pt-BR')} | Versão 1.0
            </p>
          </CardHeader>
          
          <CardContent className="prose prose-sm max-w-none">
            <h2>1. Aceitação dos Termos</h2>
            <p>
              Ao usar o <strong>Doe</strong>, você concorda com estes Termos de Uso. Não é "juridiquês" para assustar – é um acordo justo entre nós.
            </p>
            <p>
              Estes termos existem para proteger você, outros usuários e manter a comunidade segura. Se algo não fizer sentido, <strong>fale com a gente antes de continuar</strong> – estamos aqui para esclarecer.
            </p>

            <h2>2. O que é o Doe e o que ele faz</h2>
            <p>
              O <strong>Doe</strong> é uma plataforma <strong>gratuita e independente</strong> que conecta quem quer ajudar com quem precisa de sangue. Simples assim.
            </p>
            <p>
              Aqui você pode:
            </p>
            <ul>
              <li><strong>Se cadastrar como doador:</strong> Seu nome entra numa rede de pessoas dispostas a salvar vidas</li>
              <li><strong>Criar pedidos de doação:</strong> Quando você ou alguém próximo precisar, a gente espalha o pedido</li>
              <li><strong>Receber notificações:</strong> Quando alguém compatível precisar de você na sua região</li>
              <li><strong>Ver seu impacto crescer:</strong> Ranking, medalhas e reconhecimento por cada doação</li>
              <li><strong>Encontrar ajuda perto de você:</strong> Mapa com doadores, pedidos e hemocentros próximos</li>
            </ul>
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 my-4">
              <p className="text-sm text-gray-700">
                <strong>🏥 Importante:</strong> Somos uma ferramenta de conexão, não um serviço médico. A doação de sangue deve ser feita em hemocentros ou hospitais autorizados pela ANVISA. Não coletamos, armazenamos ou transfundimos sangue.
              </p>
            </div>

            <h2>3. Quem pode usar o Doe</h2>
            <p>
              Para garantir a segurança de todos:
            </p>
            <ul>
              <li>Você deve ter <strong>no mínimo 16 anos</strong> (menores de 18 precisam de autorização dos responsáveis)</li>
              <li>Doadores devem atender aos <strong>requisitos legais brasileiros</strong> para doação (peso mínimo 50kg, boa saúde, etc.)</li>
              <li>Todo mundo deve fornecer <strong>informações verdadeiras</strong> – vidas dependem disso</li>
            </ul>

            <h2>4. Sua Conta e Suas Responsabilidades</h2>
            <p>
              Seu cadastro salva vidas. Por isso, é importante que você:
            </p>
            <ul>
              <li><strong>Seja honesto:</strong> Tipo sanguíneo errado pode colocar vidas em risco. Não invente.</li>
              <li><strong>Proteja sua senha:</strong> Não compartilhe com ninguém.</li>
              <li><strong>Avise se algo estranho acontecer:</strong> Conta hackeada? Nos informe imediatamente.</li>
              <li><strong>Mantenha contatos atualizados:</strong> E-mail e WhatsApp são o jeito que conectamos você a quem precisa.</li>
            </ul>

            <p className="mt-4">
              <strong>Verificação de dados:</strong> Se algo parecer suspeito, podemos pedir documentos para confirmar sua identidade. Isso protege todo mundo. Perfis falsos são removidos sem aviso.
            </p>

            <h2>5. Como Usar a Plataforma de Forma Responsável</h2>
            <h3>5.1. O que você PODE fazer ✅</h3>
            <ul>
              <li><strong>Criar pedidos reais</strong> quando você ou alguém próximo precisar</li>
              <li><strong>Compartilhar pedidos urgentes</strong> nas redes sociais (quanto mais gente souber, melhor)</li>
              <li><strong>Conversar com respeito</strong> – estamos todos aqui para ajudar</li>
              <li><strong>Reportar perfis suspeitos</strong> – isso mantém a comunidade segura</li>
              <li><strong>Atualizar o status</strong> quando conseguir doadores (outros podem estar procurando também)</li>
            </ul>

            <h3>5.2. O que você NÃO PODE fazer ❌</h3>
            <ul>
              <li><strong>Criar pedidos falsos:</strong> Isso desvia doadores de quem realmente está em perigo.</li>
              <li><strong>Vender ou lucrar com sangue:</strong> Isso é <strong>crime federal</strong> (Lei 9.434/97). Denunciamos na hora.</li>
              <li><strong>Assediar ou discriminar:</strong> Respeito não é opcional.</li>
              <li><strong>Espalhar fake news sobre saúde:</strong> Desinformação médica mata.</li>
              <li><strong>Coletar dados para spam:</strong> Os dados aqui existem para salvar vidas, ponto.</li>
              <li><strong>Hackear ou burlar o sistema:</strong> Você prejudica quem realmente precisa.</li>
            </ul>

            <h2>6. Conteúdo do Usuário</h2>
            <h3>6.1. Propriedade</h3>
            <p>
              Você mantém a propriedade do conteúdo que publica (fotos, descrições, mensagens). Ao publicar, você nos concede uma licença não exclusiva, mundial e gratuita para exibir, reproduzir e distribuir este conteúdo na plataforma.
            </p>

            <h3>6.2. Moderação</h3>
            <p>
              Reservamo-nos o direito de remover conteúdo que viole estes termos, seja ofensivo, ilegal ou inapropriado. Podemos suspender ou excluir contas de usuários que violem repetidamente nossas políticas.
            </p>

            <h2>7. Privacidade e Dados Pessoais</h2>
            <p>
              O tratamento de seus dados pessoais é regido por nossa <a href="/politica-privacidade" className="text-red-600 hover:underline">Política de Privacidade</a>, em conformidade com a LGPD. Ao usar a plataforma, você consente com a coleta e uso de dados conforme descrito.
            </p>

            <h2>8. O que Podemos e Não Podemos Garantir</h2>
            <p>
              <strong>Transparência total:</strong> O Doe é um projeto independente feito com muito cuidado, mas <strong>não somos um serviço médico ou governamental</strong>. Somos uma ponte entre pessoas.
            </p>
            
            <h3>8.1. O que NÃO podemos garantir</h3>
            <ul>
              <li><strong>Que você sempre encontrará doadores:</strong> Dependemos de cadastros na sua região.</li>
              <li><strong>Que todos os dados são 100% verdadeiros:</strong> Fazemos verificações, mas não temos como auditar cada perfil 24/7.</li>
              <li><strong>Que o app nunca sai do ar:</strong> Fazemos manutenções, coisas quebram (somos humanos), mas corrigimos rápido.</li>
              <li><strong>Que não haverá bugs:</strong> Trabalhamos para eliminar, mas tecnologia tem surpresas.</li>
            </ul>

            <h3>8.2. Não somos responsáveis por</h3>
            <ul>
              <li><strong>Complicações médicas:</strong> Sempre consulte profissionais de saúde antes de doar.</li>
              <li><strong>Condutas de outros usuários:</strong> Alguém agiu mal? Reporte imediatamente.</li>
              <li><strong>Decisões médicas:</strong> Somos uma ponte, não um consultório.</li>
              <li><strong>Perda de dados por falhas técnicas:</strong> Fazemos backup, mas imprevistos acontecem.</li>
            </ul>

            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 my-4">
              <p className="text-sm text-gray-700">
                <strong>⚠️ Em resumo:</strong> O Doe é uma ponte entre pessoas. Não fazemos transfusões, não damos diagnósticos e não substituímos hospitais. Use com responsabilidade e sempre siga orientação médica.
              </p>
            </div>

            <h2>9. Sua Responsabilidade</h2>
            <p>
              <strong>Você</strong> é responsável por:
            </p>
            <ul>
              <li><strong>Consultar profissionais de saúde</strong> antes de doar (sério, não pule isso)</li>
              <li><strong>Doar apenas em locais autorizados</strong> (hemocentros, hospitais com ANVISA)</li>
              <li><strong>Cumprir todos os requisitos legais e médicos</strong></li>
              <li><strong>Suas interações com outros usuários</strong> (seja gente boa)</li>
              <li><strong>Proteger informações sensíveis</strong> (não espalhe dados pessoais de outros)</li>
            </ul>

            <h2>10. Propriedade Intelectual</h2>
            <p>
              Todo o código, design, logotipo e textos do <strong>Doe</strong> foram criados com horas de trabalho, café e muita dedicação.
            </p>
            <p>
              <strong>Titularidade:</strong><br />
              Doe - Rede de Doação de Sangue<br />
              CNPJ: 63.163.098/0001-18<br />
              Desenvolvido por: Luan Alysson de Souza
            </p>
            <p>
              <strong>Você pode:</strong> Usar a plataforma livremente para ajudar pessoas.<br />
              <strong>Você não pode:</strong> Copiar o código, clonar o app ou usar nossa marca sem autorização.
            </p>
            <p>
              Quer colaborar ou criar algo similar? <strong>Fale com a gente</strong> – adoramos parcerias!
            </p>

            <h2>11. Legislação Aplicável</h2>
            <p>
              <strong>Leis Relevantes:</strong>
            </p>
            <ul>
              <li><strong>Lei 9.434/97:</strong> Proíbe comercialização de sangue e órgãos</li>
              <li><strong>Portaria MS 158/2016:</strong> Regulamenta doação de sangue no Brasil</li>
              <li><strong>LGPD (Lei 13.709/2018):</strong> Proteção de dados pessoais</li>
              <li><strong>Marco Civil da Internet (Lei 12.965/2014):</strong> Direitos e deveres online</li>
            </ul>

            <h2>12. Suspensão e Encerramento</h2>
            <h3>12.1. Por Nossa Iniciativa</h3>
            <p>
              Podemos suspender ou encerrar sua conta imediatamente, sem aviso prévio, em caso de:
            </p>
            <ul>
              <li>Violação destes termos</li>
              <li>Atividade fraudulenta ou ilegal</li>
              <li>Risco à segurança de outros usuários</li>
              <li>Solicitação de autoridades competentes</li>
            </ul>

            <h3>12.2. Por Sua Iniciativa</h3>
            <p>
              Você pode excluir sua conta a qualquer momento através das configurações. Seus dados pessoais serão anonimizados conforme nossa Política de Privacidade.
            </p>

            <h2>13. Alterações nos Termos</h2>
            <p>
              Podemos atualizar estes termos periodicamente. Alterações significativas serão notificadas por e-mail ou aviso na plataforma. O uso continuado após alterações constitui aceitação dos novos termos.
            </p>

            <h2>14. Fale com a Gente</h2>
            <p>
              Dúvidas, sugestões, bugs ou só quer dar um oi? <strong>Estamos aqui para ouvir.</strong>
            </p>
            <p>
              <strong>📧 E-mail:</strong> <a href="mailto:luanalysson@gmail.com" className="text-red-600 hover:underline">luanalysson@gmail.com</a><br />
              <strong>📍 Endereço:</strong> Universidade Federal de Juiz de Fora, Campus Universitário, Juiz de Fora/MG<br />
              <strong>🏢 CNPJ:</strong> 63.163.098/0001-18
            </p>
            <p>
              <strong>Respondemos 100% das mensagens.</strong> Se algo não está funcionando, se você tem uma ideia para melhorar o app, ou se só quer agradecer – queremos saber.
            </p>

            <h2>15. Disposições Gerais</h2>
            <ul>
              <li><strong>Foro:</strong> Comarca de Juiz de Fora/MG, Brasil</li>
              <li><strong>Idioma:</strong> Em caso de conflito entre versões traduzidas, a versão em português prevalece</li>
              <li><strong>Independência:</strong> Se qualquer cláusula for considerada inválida, as demais permanecem em vigor</li>
              <li><strong>Não Renúncia:</strong> A não aplicação de qualquer direito não constitui renúncia</li>
            </ul>

            <div className="bg-red-50 border border-red-200 rounded-lg p-4 mt-6">
              <p className="text-sm text-gray-700 font-medium">
                ⚖️ <strong>Leia isso com atenção:</strong> O Doe é uma <strong>ferramenta de conexão entre pessoas</strong>. NÃO somos hemocentro, hospital ou serviço médico. NÃO coletamos, armazenamos ou transfundimos sangue. Sempre procure orientação de profissionais de saúde qualificados antes de doar.
              </p>
            </div>

            <div className="bg-green-50 border border-green-200 rounded-lg p-4 mt-4">
              <p className="text-sm text-gray-700">
                💚 <strong>Nosso compromisso:</strong> Estes termos existem para proteger você e manter a comunidade segura. <strong>Se algo não ficou claro, pergunte antes de usar.</strong> Estamos aqui para ajudar, não para complicar.
              </p>
            </div>

            <div className="text-center mt-8">
              <p className="text-sm text-gray-600 mb-4">
                Ao usar o Doe, você concorda com estes termos.<br />
                <strong>Dúvidas? Fale com a gente antes de continuar:</strong> luanalysson@gmail.com
              </p>
              <Button onClick={() => navigate('/')}>
                Voltar à Página Inicial
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
      <Footer />
    </div>
  )
}
